import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAppContext } from '../components/appprovider';
import { useAuth } from './AuthContext';

function Home() {
  const navigate = useNavigate();
  const { setUserId } = useAppContext();
  const { signIn } = useAuth();

  useEffect(() => {
    // `/` is the SSO bridge: dashboard.studyak.ai opens this window and posts
    // LOGIN_DATA. A direct visit to the bare domain never receives that message,
    // so without a fallback the page would sit blank. Handle the hand-off if it
    // comes, otherwise fall through to /login.
    let handled = false;

    const handleMessage = async (event) => {
      const allowedOrigin = 'https://dashboard.studyak.ai';
      if (event.origin !== allowedOrigin) {
        return; // ignore cross-origin noise; the fallback below handles direct visits
      }

      if (event.data?.type === 'LOGIN_DATA') {
        const payload = event.data.payload;
        if (payload && typeof payload === 'object') {
          handled = true;
          // Extract and save all fields from the payload dynamically
          Object.keys(payload).forEach((key) => {
            const value = payload[key];
            if (value !== null && value !== undefined) {
              localStorage.setItem(key, value); // Save each field to localStorage
            }
          });
          setUserId(localStorage.getItem('userId'));
          await signIn();
          navigate('/login', { replace: true });
        }
      }
    };

    window.addEventListener('message', handleMessage);

    // Direct visit (no SSO hand-off): after a short grace window for the
    // cross-origin post, send the user to the login page.
    const fallback = setTimeout(() => {
      if (!handled) navigate('/login', { replace: true });
    }, 1000);

    return () => {
      window.removeEventListener('message', handleMessage);
      clearTimeout(fallback);
    };
  }, [navigate, setUserId, signIn]);

  // Brief loading state while we decide between the SSO hand-off and /login.
  return (
    <div
      style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: '#0b0b12',
      }}
    >
      <div
        style={{
          width: 34,
          height: 34,
          borderRadius: '50%',
          border: '3px solid rgba(255,255,255,0.15)',
          borderTopColor: '#8b7bff',
          animation: 'studyak-home-spin 0.8s linear infinite',
        }}
      />
      <style>{'@keyframes studyak-home-spin{to{transform:rotate(360deg)}}'}</style>
    </div>
  );
}

export default Home;
